import { render, staticRenderFns } from "./IsRetrieval.vue?vue&type=template&id=660fa75a&scoped=true"
import script from "./IsRetrieval.vue?vue&type=script&lang=js"
export * from "./IsRetrieval.vue?vue&type=script&lang=js"
import style0 from "./IsRetrieval.vue?vue&type=style&index=0&id=660fa75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fa75a",
  null
  
)

export default component.exports